"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _transitionEnd = _interopRequireDefault(require("dom-helpers/transitionEnd"));

var _excluded = ["direction", "active", "animateIn", "animateOut", "className"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var propTypes = {
  direction: _propTypes.default.oneOf(['prev', 'next']),
  onAnimateOutEnd: _propTypes.default.func,
  active: _propTypes.default.bool,
  animateIn: _propTypes.default.bool,
  animateOut: _propTypes.default.bool,
  index: _propTypes.default.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CarouselItem, _React$Component);

  var _super = _createSuper(CarouselItem);

  function CarouselItem(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, CarouselItem);
    _this = _super.call(this, props, context);
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  } // eslint-disable-next-line camelcase


  (0, _createClass2.default)(CarouselItem, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.active !== nextProps.active) {
        this.setState({
          direction: null
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var active = this.props.active;
      var prevActive = prevProps.active;

      if (!active && prevActive) {
        (0, _transitionEnd.default)(_reactDom.default.findDOMNode(this), this.handleAnimateOutEnd);
      }

      if (active !== prevActive) {
        setTimeout(function () {
          return _this2.startAnimation();
        }, 20);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounted = true;
    }
  }, {
    key: "handleAnimateOutEnd",
    value: function handleAnimateOutEnd() {
      if (this.isUnmounted) {
        return;
      }

      if (this.props.onAnimateOutEnd) {
        this.props.onAnimateOutEnd(this.props.index);
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      if (this.isUnmounted) {
        return;
      }

      this.setState({
        direction: this.props.direction === 'prev' ? 'right' : 'left'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          direction = _this$props.direction,
          active = _this$props.active,
          animateIn = _this$props.animateIn,
          animateOut = _this$props.animateOut,
          className = _this$props.className,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      delete props.onAnimateOutEnd;
      delete props.index;
      var classes = {
        item: true,
        active: active && !animateIn || animateOut
      };

      if (direction && active && animateIn) {
        classes[direction] = true;
      }

      if (this.state.direction && (animateIn || animateOut)) {
        classes[this.state.direction] = true;
      }

      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, classes)
      }));
    }
  }]);
  return CarouselItem;
}(_react.default.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
var _default = CarouselItem;
exports.default = _default;